import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const codeApi = createApi({
  reducerPath: "codeApi",
  baseQuery: createCustomBaseQuery(`${API_BASE_URL}/code/`),
  endpoints: (builder) => ({
    // 🔹 Generate design code for a given project
    generateCode: builder.mutation<any, string>({
      query: (appProjectId) => ({
        url: "generate-code",
        method: "POST",
        body: { app_project_id: appProjectId },
      }),
    }),

    // 🔹 Regenerate existing code
    regenerateCode: builder.mutation<any, string>({
      query: (appProjectId) => ({
        url: "regenerate-code",
        method: "POST",
        body: { app_project_id: appProjectId },
      }),
    }),

    // 🔹 Fetch available color themes
    getColorThemes: builder.query<any, void>({
      query: () => ({
        url: "color-themes",
        method: "GET",
      }),
    }),

    // 🔹 Create new version (checkpoint)
    createCheckpoint: builder.mutation<any, { app_project_id: string }>({
      query: ({ app_project_id }) => ({
        url: "create-checkpoint",
        method: "POST",
        body: { app_project_id },
      }),
    }),

    // 🔹 Delete version (checkpoint)
    deleteVersion: builder.mutation<any, { app_project_id: string; version_to_delete: string }>({
      query: ({ app_project_id, version_to_delete }) => ({
        url: "delete-version",
        method: "POST",
        body: {
          app_project_id,
          version_to_delete,
        },
      }),
    }),

  }),
});

export const {
  useGenerateCodeMutation,
  useRegenerateCodeMutation,
  useGetColorThemesQuery,
  useCreateCheckpointMutation,
  useDeleteVersionMutation
} = codeApi;